var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-qrcode-form",
            title: _vm.modalTitle,
            hideHeaderClose: _vm.isSubmitted,
            size: "md",
            noFade: "",
            noCloseOnBackdrop: ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                var hide = ref.hide
                return [
                  _vm.formType === "create"
                    ? [
                        _vm.isSubmitted
                          ? _c(
                              "BaseButton",
                              {
                                attrs: {
                                  className: "btn-sm btn-web",
                                  disabled: ""
                                }
                              },
                              [_c("i", { staticClass: "fas fa-spinner spin" })]
                            )
                          : _c("BaseButton", {
                              attrs: {
                                text: _vm.$t("button.save"),
                                disabled: _vm.disabledSubmitButton,
                                className: "btn-sm btn-web"
                              },
                              on: {
                                click: function() {
                                  return _vm.handleSubmit(ok)
                                }
                              }
                            })
                      ]
                    : [
                        _vm.formType === "create"
                          ? _c("BaseButton", {
                              attrs: {
                                text: _vm.$t("button.close"),
                                className: "btn-sm btn-light"
                              },
                              on: { click: ok }
                            })
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between w-100"
                              },
                              [
                                _c("BaseButton", {
                                  attrs: {
                                    text: _vm.$t("button.delete"),
                                    disabled: _vm.isSubmitted,
                                    className: "btn-sm btn-danger"
                                  },
                                  on: {
                                    click: function() {
                                      return _vm.handleDelete(ok)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("BaseButton", {
                                  attrs: {
                                    text: _vm.$t("button.close"),
                                    disabled: _vm.isSubmitted,
                                    className: "btn-sm btn-light"
                                  },
                                  on: { click: ok }
                                })
                              ],
                              1
                            )
                      ]
                ]
              }
            }
          ])
        },
        [
          _c("QRCodeForm", {
            attrs: {
              form: _vm.form,
              isSubmitted: _vm.isSubmitted,
              branches: _vm.branches,
              posSessions: _vm.posSessions,
              disabled: _vm.formType === "edit",
              defaultValues: _vm.defaultValues
            },
            on: {
              "update:form": function($event) {
                _vm.form = $event
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-270b1a28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-270b1a28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseBModalQRCodeForm.vue
// module id = null
// module chunks = 